var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.848 44H49a1 1 0 0 0 1-1V27a1 1 0 0 0-1-1H15a1 1 0 0 0-1 1v5.122A11.19 11.19 0 0 0 12.414 32c-1.733 0-3.469.41-5.02 1.185l-1.158.579A11.758 11.758 0 0 1 1.001 35v2c2.116 0 4.236-.5 6.13-1.447l1.158-.579c3.144-1.57 7.146-1.145 9.887 1.047l5.763 4.61a2.818 2.818 0 0 1 1.062 2.209c0 .561-.164 1.104-.476 1.57l-.802 1.203-8.168-5.445-1.109 1.664 9 6a1 1 0 0 0 .398.156l16.724 2.641c.83.13 1.432.835 1.432 1.676 0 .934-.761 1.695-1.696 1.695H25c-2.462 0-4.927-.582-7.129-1.683l-5.74-2.87A13.777 13.777 0 0 0 6.001 48h-5v2h5c1.808 0 3.618.427 5.235 1.236l5.74 2.87A18.038 18.038 0 0 0 25 56h15.304A3.7 3.7 0 0 0 44 52.305a3.68 3.68 0 0 0-3.119-3.652l-15.182-2.397.49-.736a4.8 4.8 0 0 0 .659-1.52zm17.253-2A5.016 5.016 0 0 1 48 38.101V42zM48 31.899A5.016 5.016 0 0 1 44.101 28H48zM19.899 28A5.016 5.016 0 0 1 16 31.899V28zm5.289 11.069L21.352 36H25v-2h-4v1.719l-1.574-1.259a11.115 11.115 0 0 0-1.595-1.063 7.013 7.013 0 0 0 4.089-5.396h20.16a7.005 7.005 0 0 0 5.92 5.92v2.16a7.005 7.005 0 0 0-5.92 5.92H26.921a4.806 4.806 0 0 0-1.733-2.932z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 40c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zM39 34h4v2h-4zM39 11h-4V9a1.001 1.001 0 0 0-1.448-.895l-12 6a1.002 1.002 0 0 0 .001 1.79l12 6c.311.154.679.138.973-.044.294-.183.474-.504.474-.851v-2h4c8.822 0 16 7.178 16 16a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1c0-13.233-10.767-24-24-24zm17.973 23C56.452 24.538 48.59 17 39 17h-5a1 1 0 0 0-1 1v1.382L24.236 15 33 10.618V12a1 1 0 0 0 1 1h5c11.796 0 21.452 9.332 21.978 21z",
    fill: "#81A63D",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashBack);
export default __webpack_public_path__ + "static/media/cashBack.f04f29e41af16832f3d034c8a7f620d8.svg";
export { ForwardRef as ReactComponent };